// Copyright 2016 Sorama B.V.

export class InvalidParameterError extends Error {
    constructor(message: string) {
        super(message);
        this.name = "InvalidParameterError";
    }
}
